import React, { useState } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import ChatInterface from '../components/ChatInterface';
import FeedbackDisplay from '../components/FeedbackDisplay';
import { useApiKey } from '../context/ApiKeyContext';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #f8f9fa;
`;

const ChatPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setTrialBlock } = useApiKey();
  const [showFeedback, setShowFeedback] = useState(false);
  const [conversation, setConversation] = useState([]);
  const [gameResult, setGameResult] = useState(null);
  // Identifies this conversation to the trial proxy so it counts as one of the
  // free chats (and its feedback call doesn't count as a separate one). A new
  // id is minted for each "Try Again", which is a fresh conversation.
  const [conversationId, setConversationId] = useState(() => crypto.randomUUID());

  // Get the personality and character from location state
  const { personality, character, freeMode, gameMode } = location.state || {};

  // If no personality or character (e.g. the chat was opened directly or
  // refreshed — its state lives only in history, not the URL), send the user
  // back to the entry gate.
  if (!personality || !character) {
    return <Navigate to="/" replace />;
  }

  const handleEndChat = (messages, result) => {
    setConversation(messages);
    setGameResult(result);
    setShowFeedback(true);
  };

  // The trial hit a wall (exhausted or owner out of credits): record why and
  // send the user home, where the appropriate screen is shown.
  const handleTrialBlocked = (reason) => {
    setTrialBlock(reason);
    navigate('/');
  };

  const handleStartOver = () => {
    // Back to the mode step (skipping gender) — the mode screen still has a
    // "change gender?" link if they want a different gender.
    navigate(`/mode?gender=${character.gender}`);
  };

  const handleTryAgain = () => {
    setShowFeedback(false);
    setConversation([]);
    setGameResult(null);
    setConversationId(crypto.randomUUID());
  };

  return (
    <Container>
      {showFeedback ? (
        <FeedbackDisplay
          conversation={conversation}
          character={character}
          personality={personality}
          gameMode={gameMode}
          gameResult={gameResult}
          conversationId={conversationId}
          onStartOver={handleStartOver}
          onTryAgain={handleTryAgain}
          onTrialBlocked={handleTrialBlocked}
        />
      ) : (
        <ChatInterface
          personality={personality}
          character={character}
          freeMode={freeMode}
          gameMode={gameMode}
          conversationId={conversationId}
          onEndChat={handleEndChat}
          onTrialBlocked={handleTrialBlocked}
        />
      )}
    </Container>
  );
};

export default ChatPage;
